/* eslint-disable quotes,flowtype/require-valid-file-annotation,indent,no-var,no-unused-expressions,curly */
export default function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
}



// WEBPACK FOOTER //
// ./web_modules/d3-brush/src/event.js